var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApplicationInProgress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4957 3.6111L5.1977 10.6464C5.15174 10.6907 5.09527 10.723 5.03224 10.7401L1.24766 11.7824C1.21286 11.7919 1.1774 11.7963 1.1426 11.7963C1.04214 11.7963 0.944967 11.7584 0.872086 11.6881C0.774254 11.5932 0.736829 11.4552 0.774911 11.3261L1.85631 7.6784C1.87404 7.61828 1.90753 7.56322 1.95349 7.51892L9.25214 0.484839C9.92251 -0.161929 11.0144 -0.161297 11.6848 0.484839L12.4957 1.2664C12.8207 1.57903 12.9999 1.99608 12.9999 2.43907C12.9999 2.88143 12.8207 3.29784 12.4957 3.6111ZM1.69939 10.8901L2.56412 7.97204L8.44059 2.30744L10.6034 4.39203L4.72692 10.0566L1.69939 10.8901ZM11.1444 1.00567C10.7715 0.646848 10.1648 0.646848 9.79251 1.00567L8.98162 1.78724L11.1444 3.87183L11.9553 3.09027C12.1359 2.91623 12.235 2.68461 12.235 2.43843C12.235 2.19226 12.1359 1.96127 11.9553 1.78724L11.1444 1.00567Z",
    fill: "#2D2943"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationInProgress);
export default __webpack_public_path__ + "static/media/application-in-progress.af03057d.svg";
export { ForwardRef as ReactComponent };